import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { MatButtonModule } from '@angular/material/button';

export interface ButtonValue {
  isActive: boolean;
  value: string;
}

@Component({
  selector: 'app-toggle-buttons',
  templateUrl: './toggle-buttons.component.html',
  styleUrls: ['./toggle-buttons.component.scss'],
  standalone: true,
  imports: [MatTooltipModule, CommonModule, FlexLayoutModule, MatButtonModule]
})
export class ToggleButtonsComponent {
  @Input() buttons: ButtonValue[] = [];
  @Input() isInvalid: boolean = true;
  @Input() label: string = '';
  @Input() toolTip: string = '';
  @Input() disabled: boolean = false;
  @Output() toggleClicked: EventEmitter<string> = new EventEmitter();

  setValue(button: ButtonValue) {
    if (!this.disabled) {
      this.buttons.map(item => {
        item.isActive = item.value === button.value;
      });

      this.isInvalid = false;
      this.toggleClicked.emit(button.value);
    }
  }
}
